import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1458.94844,1305.62602 C1563.58502,1168.67679 1626.47541,998.439035 1626.47541,813.237703 C1626.47541,364.764218 1261.71119,0 813.237703,0 C364.764218,0 0,364.764218 0,813.237703 C0,1261.71119 364.764218,1626.47541 813.237703,1626.47541 C998.439035,1626.47541 1168.78523,1563.58502 1305.73446,1458.94844 L1766.67759,1920 L1920,1766.67759 L1458.94844,1305.62602 Z M813.237703,1409.61202 C484.364376,1409.61202 216.863387,1142.0026 216.863387,813.237703 C216.863387,484.472807 484.364376,216.863387 813.237703,216.863387 C1142.11103,216.863387 1409.61202,484.472807 1409.61202,813.237703 C1409.61202,1142.0026 1142.11103,1409.61202 813.237703,1409.61202 L813.237703,1409.61202 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSearchAddressBookSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconSearchAddressBookSolid, _Component);

  var _super = _createSuper(IconSearchAddressBookSolid);

  function IconSearchAddressBookSolid() {
    _classCallCheck(this, IconSearchAddressBookSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconSearchAddressBookSolid, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('<IconSearchAddressBookSolid /> is deprecated. Please use <IconSearchSolid /> instead.');
      }

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSearchAddressBook",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconSearchAddressBookSolid.displayName = "IconSearchAddressBookSolid";
  return IconSearchAddressBookSolid;
}(Component);

IconSearchAddressBookSolid.glyphName = 'search-address-book';
IconSearchAddressBookSolid.variant = 'Solid';
IconSearchAddressBookSolid.deprecated = true;
IconSearchAddressBookSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSearchAddressBookSolid;
export { IconSearchAddressBookSolid };